import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import client, { apiErr } from "@/lib/api";

const SITES = { engineering: "https://www.entrancezone.com/engineering", jobs: "https://www.entrancezone.com/jobs" };

const SiteForm = ({ site, st, onDone }) => {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);
  const connect = async () => {
    setBusy(true);
    try { const r = await client.post(`/wp/sites/${site}/connect`, { url: SITES[site], username: u, app_password: p }); if (r.data.auth_ok === false) { toast.error(`/${site}: WordPress rejected the application password — nothing stored`); } else { toast.success(`/${site} connected securely`); setP(""); onDone(); } }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-slate-200 p-3 text-sm" data-testid={`wp-site-${site}`}>
      <div className="flex items-center justify-between"><b>/{site}</b><span className={`rounded px-1.5 py-0.5 text-[10px] font-bold ${st?.connected ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`} data-testid={`wp-site-${site}-status`}>{st?.connected ? `connected · ${st.username}${st.auth_ok === false ? " · read-only" : ""}` : "read-only inventory (public REST)"}</span></div>
      <div className="mt-1 text-[11px] text-slate-500">{st?.crawl ? `${st.crawl.posts} posts crawled ${String(st.crawl.at).slice(0, 10)}` : "not crawled yet"} · {st?.write_path}</div>
      <div className="mt-2 flex flex-wrap gap-2">
        <input data-testid={`wp-site-${site}-user`} value={u} onChange={(e) => setU(e.target.value)} placeholder="WP username" className="rounded border border-slate-300 px-2 py-1 text-xs" />
        <input data-testid={`wp-site-${site}-pass`} value={p} onChange={(e) => setP(e.target.value)} type="password" placeholder="Application password (stored encrypted, never shown)" className="w-72 rounded border border-slate-300 px-2 py-1 text-xs" />
        <button data-testid={`wp-site-${site}-connect`} disabled={busy || !u || !p} onClick={connect} className="rounded bg-slate-900 px-3 py-1 text-xs font-semibold text-white disabled:opacity-50">{st?.connected ? "Re-connect" : "Connect securely"}</button>
      </div>
    </div>
  );
};

export const WpSites = () => {
  const [st, setSt] = useState(null);
  const load = useCallback(async () => { try { const r = await client.get("/wp/sites"); setSt(r.data); } catch (e) { toast.error(apiErr(e)); } }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6" data-testid="wp-sites-panel">
      <h2 className="font-serif text-lg font-bold text-slate-900">Additional WordPress installs (Chief inventory)</h2>
      <p className="mb-3 text-sm text-slate-600">Same secure integration as the main site: the application password is tested, stored encrypted-at-rest and never returned to the browser or chat. Until connected, the Chief reads these installs through the public REST API only.</p>
      <div className="grid gap-3 md:grid-cols-2">{Object.keys(SITES).map((s) => <SiteForm key={s} site={s} st={st?.[s]} onDone={load} />)}</div>
    </div>
  );
};
